import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Icon } from 'shared/components';

import ChromeIcon from './assets/chrome.js';
import EdgeIcon from './assets/edge';

import theme from './BrowserNotSupported.scss';

export default () => (
  <div className={ theme.root }>
    <div className={ theme.titleWrap }>
      <Icon name="exclamation-outline" className={ theme.exclamationIcon } />
      <p className={ theme.title }>
        <FormattedMessage
          id="BrowserNotSupportedMessage.Title"
          defaultMessage="** Browser not supported"
        />
      </p>
    </div>

    <div className={ theme.body }>
      <p>
        <FormattedMessage
          id="BrowserNotSupportedMessage.Body.withEdge"
          defaultMessage="** To insure an optimal user experience, please make sure you have the latest version of Chrome or Edge"
        />
      </p>
      <div className={ theme.iconsGroup }>
        <a href="https://www.google.com/chrome/" target="_blank" rel="noopener noreferrer" className={ theme.chromeLink }>
          <ChromeIcon />
          <span className={ theme.caption }>Chrome</span>
        </a>
        <a href="https://www.microsoft.com/en-us/edge/download" target="_blank" rel="noopener noreferrer" className={ theme.edgeLink }>
          <EdgeIcon />
          <span className={ theme.caption }>Edge</span>
        </a>
      </div>
    </div>
  </div>
);
